// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"br","header":"bs","title":"bt","subHeader":"bu","footer":"bv"};